

export const ES_WXMIN_APPID = 'wxe4b1c6ad65cf329a'; // 企业滴滴小程序id
export const PS_WXMIN_APPID = 'wxaf35009675aa0b2a'; // 主端小程序ID

export const wxConfig = {
  [ES_WXMIN_APPID]: {
    srvno: 'didies',
    _caller: 'didies_wxmini',
    source: 'weixin',
  },
  [PS_WXMIN_APPID]: {
    srvno: 'didichuxing',
    _caller: 'didies_wxmini',
    source: 'weixin',
  },
};

// 获取 微信小程序 appId
export const getWXAppid = () => {
    const reg = /miniProgram\/[\w]+/ig; // 官方没有公布appid的格式，目前是小写字母+数字
    const miniAppid = reg.exec(window.navigator.userAgent);
    return miniAppid ? miniAppid[0].split('/')[1] : null;
};